import { createFileRoute } from '@tanstack/react-router'

import { LearnpathsCreatorStepZero } from '@/learnpaths-creator/components/LearnpathsCreatorStepZero/LearnpathsCreatorStepZero'

export const Route = createFileRoute(
  '/company/learnpaths/add/general-information-course',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <LearnpathsCreatorStepZero isNewCoursePage />
}
